import React from 'react';
import {TableCell, TableRow} from "@mui/material";
import {calculateReduction, formatCurrency} from "../../utils/helpers";


const ReductionRecapRow = ({
                               price, quantity, discountType, discountValue, options
                           }) => {

    return (
        <React.Fragment>
            {discountType !== 'none' && (
                <TableRow>
                    <TableCell></TableCell>
                    <TableCell colSpan={3} sx={{background: "lightgray"}}>
                        Réduction
                    </TableCell>
                    <TableCell align="right" sx={{background: "lightgray"}}>
                        - {formatCurrency(calculateReduction(price, quantity, discountType, discountValue, options))}
                    </TableCell>
                </TableRow>
            )}</React.Fragment>
    )
}

export default ReductionRecapRow;